import React from "react";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";

function SimpleTextField({
  value,
  name,
  component,
  label,
  error,
  onChange,
  required,
  type,
  newValues,
  ...props
}) {
  const ComponentTag = component;
  return (
    <div>
      <Typography color="#666666" sx={{ mb: 0.6 }}>
        {label} {required ? "*" : ""}
      </Typography>

      {component ? (
        <ComponentTag
          name={name}
          value={value}
          type={type}
          newValues={newValues}
          {...props}
        />
      ) : (
        <TextField
          size="small"
          fullWidth
          name={name}
          value={value}
          onChange={onChange}
          type={type}
          {...props}
        />
      )}

      {error && <Typography color="red">{error}</Typography>}
    </div>
  );
}

export default SimpleTextField;
